"use strict";

require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.object.define-property.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatDateValue = exports.formatDateTimeString = exports.disabledDatesFromProps = exports["default"] = exports.date_input_regex = void 0;
Object.defineProperty(exports, "validations", {
  enumerable: true,
  get: function get() {
    return _validations.validations;
  }
});
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
require("core-js/modules/es.date.to-string.js");
require("core-js/modules/es.regexp.constructor.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.object.values.js");
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = _interopRequireDefault(require("lodash"));
var _moment = _interopRequireDefault(require("moment"));
var _DayPickerInput = _interopRequireDefault(require("react-day-picker/DayPickerInput"));
require("react-day-picker/lib/style.css");
var _moment2 = require("react-day-picker/moment");
var _formElements = require("@evidation/form-elements");
var _components = require("./components");
var _reactI18next = require("react-i18next");
var _LanguageContext = require("../../contexts/LanguageContext");
var _time = _interopRequireDefault(require("../time"));
var _dateFns = require("date-fns");
var _validations = require("./validations");
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var disabledDatesFromProps = exports.disabledDatesFromProps = function disabledDatesFromProps(_ref) {
  var datetimepicker_disable_future = _ref.datetimepicker_disable_future,
    datetimepicker_date_range = _ref.datetimepicker_date_range,
    datetimepicker_date_range_units = _ref.datetimepicker_date_range_units;
  var disabledDates = {};
  if (datetimepicker_disable_future) {
    var after = new Date();
    after.setHours(0, 0, 0, 0);
    disabledDates.after = after;
  }
  if (datetimepicker_date_range && datetimepicker_date_range_units) {
    var before = (0, _moment["default"])().subtract(datetimepicker_date_range, datetimepicker_date_range_units).toDate();
    before.setHours(0, 0, 0, 0);
    disabledDates.before = before;
  }
  return disabledDates;
};
var year_regex = /[0-9]{4}/;
var month_regex = /([1-9]|0[1-9]|1[0-2])/;
var day_regex = /([1-9]|0[1-9]|[1-2][0-9]|3[0-1])/;
var date_input_regex = exports.date_input_regex = RegExp('^' + month_regex.source + '/' + day_regex.source + '/' + year_regex.source + '$');
var formatDateValue = exports.formatDateValue = function formatDateValue(date) {
  return !_lodash["default"].isUndefined(date) && date !== '' ? (0, _moment["default"])(date, ['MM/DD/YYYY', 'M/DD/YYYY', 'MM/D/YYYY', 'M/D/YYYY']).format('YYYY-MM-DD') : "";
};
var formatDateTimeString = exports.formatDateTimeString = function formatDateTimeString(date, time) {
  return _lodash["default"].isEmpty(date) && _lodash["default"].isEmpty(time) ? '' : "".concat(date, "T").concat(time);
};
var DatetimePicker = /*#__PURE__*/function (_React$Component) {
  function DatetimePicker(props) {
    var _props$input, _props$input2, _props$input3;
    var _this;
    (0, _classCallCheck2["default"])(this, DatetimePicker);
    _this = _callSuper(this, DatetimePicker, [props]);
    (0, _defineProperty2["default"])(_this, "touched", function () {
      var _this$props = _this.props,
        datetimepicker_disable_date = _this$props.datetimepicker_disable_date,
        datetimepicker_disable_time = _this$props.datetimepicker_disable_time;
      if (datetimepicker_disable_date) {
        return _this.state.time_touched;
      } else if (datetimepicker_disable_time) {
        return _this.state.date_touched;
      } else {
        return _this.state.date_touched && _this.state.time_touched;
      }
    });
    (0, _defineProperty2["default"])(_this, "nextValue", function (date, dayPickerInput) {
      if (date) {
        return date;
      } else {
        return date_input_regex.test(dayPickerInput.input.value) ? dayPickerInput.input.value : '';
      }
    });
    (0, _defineProperty2["default"])(_this, "onDateChange", function (date, modifiers, dayPickerInput) {
      var nextValue = _this.nextValue(date, dayPickerInput);
      var formattedDate = formatDateValue(nextValue);
      var value = _this.props.datetimepicker_disable_time ? formattedDate : formatDateTimeString(formattedDate, _this.state.time);
      _this.setState({
        date: formattedDate,
        noFormat: date,
        value: value
      });
      _this.onChange(value);
    });
    (0, _defineProperty2["default"])(_this, "onTimeChange", function (e) {
      var time = e !== null ? (0, _moment["default"])(e, 'h:mm a').format('HH:mm:ssZ') : "";
      var value = _this.props.datetimepicker_disable_date ? time : formatDateTimeString(_this.state.date, time);
      _this.setState({
        time: time,
        value: value
      });
      _this.onChange(value);
    });
    (0, _defineProperty2["default"])(_this, "onDateBlur", function (e) {
      _this.setState({
        date_touched: true
      });
      _this.props.input.onBlur();
    });
    (0, _defineProperty2["default"])(_this, "onTimeBlur", function (e) {
      _this.setState({
        time_touched: true
      });
      _this.props.input.onBlur();
    });
    (0, _defineProperty2["default"])(_this, "onFocus", function (e) {
      return _this.props.input.onFocus(e);
    });
    if ((props === null || props === void 0 ? void 0 : (_props$input = props.input) === null || _props$input === void 0 ? void 0 : _props$input.value) !== 'set_by_exclusive_input' && (props === null || props === void 0 ? void 0 : (_props$input2 = props.input) === null || _props$input2 === void 0 ? void 0 : _props$input2.value) !== '' && (props === null || props === void 0 ? void 0 : (_props$input3 = props.input) === null || _props$input3 === void 0 ? void 0 : _props$input3.value) !== undefined) {
      var _Date, _props$input4, _Date2, _props$input5, _Date3, _props$input6;
      _this.state = {
        value: '',
        date: (_Date = new Date(props === null || props === void 0 ? void 0 : (_props$input4 = props.input) === null || _props$input4 === void 0 ? void 0 : _props$input4.value)) !== null && _Date !== void 0 ? _Date : '',
        time: (_Date2 = new Date(props === null || props === void 0 ? void 0 : (_props$input5 = props.input) === null || _props$input5 === void 0 ? void 0 : _props$input5.value)) !== null && _Date2 !== void 0 ? _Date2 : '',
        noFormat: (_Date3 = new Date(props === null || props === void 0 ? void 0 : (_props$input6 = props.input) === null || _props$input6 === void 0 ? void 0 : _props$input6.value)) !== null && _Date3 !== void 0 ? _Date3 : '',
        date_touched: false,
        time_touched: false
      };
    } else {
      _this.state = {
        value: '',
        date: '',
        time: '',
        noFormat: '',
        date_touched: false,
        time_touched: false
      };
    }
    _this.onChange = _lodash["default"].isFunction(props.onChange) ? props.onChange : _this.props.input.onChange;
    _this.disabledDates = disabledDatesFromProps(props);
    return _this;
  }
  (0, _inherits2["default"])(DatetimePicker, _React$Component);
  return (0, _createClass2["default"])(DatetimePicker, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.input.value !== this.props.input.value) {
        if (this.props.input.value === 'set_by_exclusive_input') {
          this.setState({
            value: '',
            date: '',
            time: '',
            noFormat: ''
          });
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        _this$props2$meta = _this$props2.meta,
        error = _this$props2$meta.error,
        touched = _this$props2$meta.touched,
        name = _this$props2.input.name,
        inputStyle = _this$props2.inputStyle,
        label = _this$props2.label,
        smallLabel = _this$props2.smallLabel,
        labelStyle = _this$props2.labelStyle,
        required = _this$props2.required,
        timeFormat = _this$props2.timeFormat,
        disabled = _this$props2.disabled,
        time_placeholder = _this$props2.time_placeholder,
        date_placeholder = _this$props2.date_placeholder,
        datetimepicker_disable_date = _this$props2.datetimepicker_disable_date,
        datetimepicker_disable_time = _this$props2.datetimepicker_disable_time,
        t = _this$props2.t,
        language = _this$props2.i18n.language;
      var months = Object.values(t('common.months', {
        returnObjects: true
      }));
      var weekDayLong = Object.values(t('common.weekDayLong', {
        returnObjects: true
      }));
      var weekDayShort = Object.values(t('common.weekDayShort', {
        returnObjects: true
      }));
      var noFormat = this.state.noFormat;
      return /*#__PURE__*/_react["default"].createElement(_formElements.InputLabel, {
        required: required,
        label: label || smallLabel,
        labelStyle: labelStyle || inputStyle,
        id: name
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          display: 'flex'
        }
      }, !datetimepicker_disable_date && /*#__PURE__*/_react["default"].createElement(_components.DayPickerWrapper, null, /*#__PURE__*/_react["default"].createElement(_DayPickerInput["default"], {
        value: noFormat,
        formatDate: _moment2.formatDate,
        parseDate: _moment2.parseDate,
        onDayChange: this.onDateChange,
        inputProps: {
          onFocus: this.onFocus,
          onBlur: this.onDateBlur,
          disabled: disabled,
          id: "".concat(name, "_daypicker")
        },
        placeholder: date_placeholder,
        dayPickerProps: {
          todayButton: t('common.today'),
          disabledDays: this.disabledDates,
          locale: language,
          months: months,
          weekdaysLong: weekDayLong,
          weekdaysShort: weekDayShort
        },
        format: ['MM/DD/YYYY'],
        disabled: disabled,
        keepFocus: false
      })), !datetimepicker_disable_time && /*#__PURE__*/_react["default"].createElement(_components.TimeWrapper, {
        timeOnly: datetimepicker_disable_date
      }, /*#__PURE__*/_react["default"].createElement(_time["default"], {
        id: "".concat(name, "_timepicker"),
        format: timeFormat,
        use12Hours: true,
        input: {
          onBlur: this.onTimeBlur,
          onFocus: this.onFocus,
          onChange: this.onTimeChange,
          value: this.state.time
        },
        disabled: disabled,
        placeholder: time_placeholder,
        allowClear: !disabled
      }))), touched && this.touched() && error && /*#__PURE__*/_react["default"].createElement(_formElements.InputError, null, error));
    }
  }]);
}(_react["default"].Component);
DatetimePicker.defaultProps = {
  datetimepicker_hours_start: 0,
  datetimepicker_hours_end: 24,
  datetimepicker_disable_future: false,
  default_select_value: "MM/DD/YYYY",
  disabled: false,
  inputStyle: "achievement",
  labelStyle: "dark",
  dateFormat: 'MM/DD/YYYY',
  timeFormat: 'h:mm a',
  date_placeholder: '',
  time_placeholder: '',
  datetimepicker_disable_date: false,
  datetimepicker_disable_time: false
};
DatetimePicker.propTypes = {
  datetimepicker_date_range: _propTypes["default"].number,
  datetimepicker_date_range_units: _propTypes["default"].oneOf(["days", "weeks"]),
  datetimepicker_hours_start: _propTypes["default"].number,
  datetimepicker_hours_end: _propTypes["default"].number,
  datetimepicker_disable_future: _propTypes["default"].bool,
  date_placeholder: _propTypes["default"].string,
  time_placeholder: _propTypes["default"].string,
  datetimepicker_disable_date: _propTypes["default"].bool,
  datetimepicker_disable_time: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  label: _propTypes["default"].string,
  onChange: _propTypes["default"].func
};
var DatetimePickerWithTranslation = (0, _reactI18next.withTranslation)(_LanguageContext.curiousPandaNamespace)(DatetimePicker);
DatetimePickerWithTranslation.handlesErrorDisplay = true;
var _default = exports["default"] = DatetimePickerWithTranslation;